import React, { useContext } from 'react'
import { Field, Form, Formik } from 'formik';
import ValidationError from '../Errors/ValidationError';
import { getImages } from '../Common/const';
import { VehicleContext } from '../Context/VehicleContext';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';

const ScheduleAppointment  = () => {

    const {submitContactForm} = useContext(VehicleContext);

    const recaptchaRef = React.useRef();

    const navigate = useNavigate();
    
    return (
        <>
            <Formik
                // validationSchema={validationSchema}
                initialValues={{
                    full_name: '',
                    email: '',
                    phone: '',
                    comment: '',
                    vin: '',
                    year: '',
                    make: '',
                    model: '',
                    trim: '',
                    mileage: '',
                    exterior: ''
                }}
                onSubmit={async (values, { resetForm }) => {
                    const token = await recaptchaRef.current.executeAsync();
                    recaptchaRef.current.reset(); // Reset after use
                    values = { ...values, token: token };
                    console.log(values);
                    const data = await submitContactForm(values);
                    if (data.success) {
                        resetForm();
                        navigate("/thank-you");
                    } else
                        alert("There was a problem with your submission");
                }}
            >
                {({ values, setFieldValue, field, form }) => (
                    <Form className="custom-form schedule-appointment-form" autoComplete="off" name="contact-form">
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey="6Lf_fF8sAAAAAOJtVcUfUDNeLHqTqrPaWd27x9ej" // Replace with your actual site key
                            size="invisible"
                        /> 
                        <div className='row'>
                            <div className='col-lg-4 col-md-5 wow fadeInUp' data-wow-delay="0.2s">
                                <div className='form-group'>
                                    <div className='d-flex align-items-center justify-content-between mb-2'>
                                        <div className='cs-label'>Full Name</div>
                                        <div className='cs-require'>* Required</div>
                                    </div>
                                    <Field
                                        type="text"
                                        name="full_name"
                                        className="form-control"
                                        required />
                                    <ValidationError name="full_name" />
                                </div>
                                <div className='form-group'>
                                    <div className='d-flex align-items-center justify-content-between mb-2'>
                                        <div className='cs-label'>Email</div>
                                        <div className='cs-require'>* Required</div>
                                    </div>
                                    <Field
                                        type="text"
                                        name="email"
                                        className="form-control"
                                        required />
                                    <ValidationError name="email" />
                                </div>
                                <div className='form-group'>
                                    <div className='cs-label mb-2'>Phone Number</div>
                                    <Field
                                        type="text"
                                        name="phone"
                                        className="form-control"
                                        required />
                                    <ValidationError name="phone" />
                                </div>
                            </div>
                            <div className='col-lg-8 col-md-7 wow fadeInUp' data-wow-delay="0.4s">
                                <div className='form-group'>
                                    <div className='cs-label mb-2'>Comments</div>
                                    <Field
                                        type="text"
                                        name="comment"
                                        className="form-control h-218"
                                        component="textarea" />
                                    <ValidationError name="comment" />
                                </div>
                            </div>
                        </div>
                        <div className='row mt-4 justify-content-between about-action-flex wow fadeInUp' data-wow-delay="0.6s">
                            <div className='col-md-6 text-end order-md-2'>
                                <button className='btn-theme lg-btn w-300'>Send</button>
                            </div>
                            <div className='col-md-6 fb-contact-info'>
                                <a href='tel:8309815050' className='d-inline-flex align-items-center phone-no-text mb-2'>
                                    <span className='call-icon me-2'>
                                        <img src={getImages('call.png')} alt='call' />
                                    </span> 
                                    <span>830-981-5050</span>
                                </a>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    )
}

export default ScheduleAppointment 